import { QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { SectionErrors } from '../../../types';
import { EmptyTitlesAreNotAllowed } from '../../../displayStrings';

type ContentBoxErrorsProps = {
  sectionErrors: SectionErrors;
};

const ContentBoxErrors = (props: ContentBoxErrorsProps) => {
  const { t } = useTranslation();
  return (
    <div>
      {props.sectionErrors.titleBlank && <QText color={'red'}>{EmptyTitlesAreNotAllowed}</QText>}
      {props.sectionErrors.duplicateTitle && (
        <QText color={'red'}>{t('common.errors.duplicateTitlesNotAllowed')}</QText>
      )}
      {props.sectionErrors.invalidCharacters !== '' && (
        <QText color={'red'}>
          {t('common.errors.invalidCharactersInTitle', { characters: props.sectionErrors.invalidCharacters })}
        </QText>
      )}
    </div>
  );
};

export default ContentBoxErrors;
